module.exports = __webpack_public_path__ + "media/images/elta-04eb0823197ebec8cf538d498a92083d.png";